// src/components/study/StudyCard.js
//
// The glass card every section of StudyDetailsPage sits in. Extracted so the
// screening cards in this folder render inside the identical frame rather than
// a near-copy of it.

const StudyCard = ({ title, subtitle, icon, actions, children }) => (
  <div className="relative rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-2xl p-4 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-purple-500/[0.05] via-transparent to-blue-500/[0.05] pointer-events-none" />
    <div className="relative">
      <div className="mb-3 flex items-center gap-2">
        {icon && (
          <div className="w-7 h-7 rounded-lg bg-white/[0.04] border border-white/10 flex items-center justify-center">
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <h3 className="text-[11px] uppercase tracking-[0.22em] font-semibold text-white leading-tight">
            {title}
          </h3>
          {subtitle && <p className="text-[10px] text-slate-400 leading-tight mt-0.5">{subtitle}</p>}
        </div>
        <span className="ml-auto h-px flex-1 bg-white/5" />
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
      {children}
    </div>
  </div>
);

export default StudyCard;
